module.exports = __webpack_public_path__ + "img/Kacper Cwiokowski.e6c05197.webp";